import UserRoutes from './Routes';

export const App = () => <UserRoutes />;
